

import { api } from "../api";
import { AddTicketPriorityRequest, AttachmentTicketsResponse, PriorityTicketResponse, TicketHistoricoResponse, TicketReferenciaExterna, TicketRequest, TicketResponse } from "../../types/tickets/types";
import { formatDate } from "../../utils/utils";



export const fetchTicketsAtendimento = async (filters: TicketRequest): Promise<TicketResponse> => {
    const { data } = await api.get('/ticket/buscarmeusticketsatendimento', {
        params: {
            ...filters,
            dataInicial: formatDate(filters.dataInicial),
            dataFinal: formatDate(filters.dataFinal),
        }
    });
    return data;
};

export const fetchPriorityTicketsAtendimento = async (oidCliente: number): Promise<PriorityTicketResponse[]> => {
    const { data } = await api.get('/ticket/buscarpriorizacaoticketsatendimento', {
        params: {
            oidCliente
        }
    });
    return data;
};


export const fetchTicketsDesenvolvimento = async (filters: TicketRequest): Promise<TicketResponse> => {
    const { data } = await api.get('/ticket/buscarmeusticketsdesenvolvimento', {
        params: {
            ...filters,
            dataInicial: formatDate(filters.dataInicial),
            dataFinal: formatDate(filters.dataFinal),
        }
    });
    return data;
};

export const fetchPriorityTicketsDesenvolvimento = async (oidCliente: number): Promise<PriorityTicketResponse[]> => {
    const { data } = await api.get('/ticket/buscarpriorizacaoticketsdesenvolvimento', {
        params: {
            oidCliente
        }
    });
    return data;
};

export const fetchAttachmentTicket = async (numeroTopicoPreAtendimento : number): Promise<AttachmentTicketsResponse> => {
    const { data } = await api.get('/ticket/buscaranexoticket', {
        params: {
            numeroTopicoPreAtendimento
        }
    });
    return data;
};

export const fetchTicketsOrdemServico = async (filters: TicketRequest): Promise<TicketResponse> => {
    const { data } = await api.get('/ticket/buscarmeusticketsordemdeservico', {
        params: {
            ...filters,
            dataInicial: formatDate(filters.dataInicial),
            dataFinal: formatDate(filters.dataFinal),
        }
    });
    return data;
};

export const fetchPriorityTicketsOrdemServico = async (oidCliente: number): Promise<PriorityTicketResponse[]> => {
    const { data } = await api.get('/ticket/buscarpriorizacaoticketsordemdeservico', {
        params: {
            oidCliente
        }
    });
    return data;
};

export const fetchTicketDetails = async (ticketId: number): Promise<TicketHistoricoResponse> => {
    const { data } = await api.get(`/ticket/buscarhistoricoatendimentoticketespecifico`, {
        params: {
            numeroTicket: ticketId
        }
    });
    return data;
};

export const fetchTicketsHistoricoTransacao = async (filters: TicketRequest): Promise<TicketResponse> => {
    const { data } = await api.get('/ticket/buscarmeusticketshistoricotransacao', {
        params: {
            ...filters,
            dataInicial: formatDate(filters.dataInicial),
            dataFinal: formatDate(filters.dataFinal),
        }
    });
    return data;
};


export const exportTicketsAtendimento = async (filters: TicketRequest): Promise<Blob> => {
    const { data } = await api.get('/ticket/exportarmeusticketsatendimento', {
        params: {
            ...filters,
            dataInicial: formatDate(filters.dataInicial),
            dataFinal: formatDate(filters.dataFinal),
        },
        responseType: 'blob',
    });
    return data;
};

export const exportTicketsDesenvolvimento = async (filters: TicketRequest): Promise<Blob> => {
    const { data } = await api.get('/ticket/exportarmeusticketsdesenvolvimento', {
        params: {
            ...filters,
            dataInicial: formatDate(filters.dataInicial),
            dataFinal: formatDate(filters.dataFinal),
        },
        responseType: 'blob',
    });
    return data;
};

export const exportTicketsOrdemServico = async (filters: TicketRequest): Promise<Blob> => {
    const { data } = await api.get('/ticket/exportarmeusticketsordemdeservico', {
        params: {
            ...filters,
            dataInicial: formatDate(filters.dataInicial),
            dataFinal: formatDate(filters.dataFinal),
        },
        responseType: 'blob',
    });
    return data;
};

export const exportTicketsHistoricoTransacao = async (filters: TicketRequest): Promise<Blob> => {
    const { data } = await api.get('/ticket/exportarmeusticketshistoricotransacao', {
        params: {
            ...filters,
            dataInicial: formatDate(filters.dataInicial),
            dataFinal: formatDate(filters.dataFinal),
        },
        responseType: 'blob',
    });
    return data;
};


export const creatDirectChannelRequest = async (numeroficha: number): Promise<void> => {
    const { data } = await api.post('/atendimentos/criarsolicitacaocanaldireto', {
        numeroficha
    });

    return data;
};


export const addTicketPriority = async (request: AddTicketPriorityRequest): Promise<void> => {
    const { data } = await api.post('/fichas/adicionarprioridadecliente ', {
        ...request
    });

    return data;
};


export const fetchTicketReferenciaExterna = async (referenciaExterna: string): Promise<TicketReferenciaExterna> => {
    const { data } = await api.get(`/ticket/feedback/${referenciaExterna}`);

    return data;
};
